import React from "react";
import "./Input.css";
import { injectIntl } from "react-intl";

export const Input = props => {
  return <input className="Input" {...props} />;
};

const LocalizedInput = props => {
  const localizedPlaceholder = props.intl.formatMessage({ id: props.placeholder });
  return <Input {...props} placeholder={localizedPlaceholder} />;
};

export default injectIntl(LocalizedInput);



// WEBPACK FOOTER //
// ./src/components/Input.js